export const defaultEntityOptionsProps = {
    optionValue: 'ID',
    optionLabel: 'NAME'
}
